import { request } from '@/utils/request'
import SearchResult from './models/searchResult'

export default {
    async getRecommendations(entityType, entityId) {
        const params = {
            type: entityType,
            id: entityId,
        }

        return SearchResult.fromArray(await request.get('/api/recommendations', params))
    },
    async getRecentlyViewed() {
        return SearchResult.fromGrouped(await request.get('/api/recommendations/recent'))
    },
}
